var map = {
	"./BUGHUNTER_LEVEL_1.svg": "ca98",
	"./BUGHUNTER_LEVEL_2.svg": "1037",
	"./DISCORD_CERTIFIED_MODERATOR.svg": "8863",
	"./DISCORD_EMPLOYEE.svg": "9cd0",
	"./EARLY_SUPPORTER.svg": "99ae",
	"./EARLY_VERIFIED_BOT_DEVELOPER.svg": "a8b1",
	"./EARLY_VERIFIED_DEVELOPER.svg": "8f11",
	"./HOUSE_BALANCE.svg": "e394",
	"./HOUSE_BRAVERY.svg": "7fe8",
	"./HOUSE_BRILLIANCE.svg": "b680a",
	"./HYPESQUAD_EVENTS.svg": "a704",
	"./NITRO.svg": "e6cd",
	"./PARTNERED_SERVER_OWNER.svg": "a8b5",
	"./SYSTEM.svg": "58e3",
	"./TEAM_USER.svg": "d49f",
	"./THANKS_1.svg": "b47a",
	"./THANKS_2.svg": "a25d",
	"./THANKS_3.svg": "7ff3",
	"./THANKS_4.svg": "f898",
	"./VERIFIED_BOT.svg": "2faa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cdc1";